<template>
  <div>
    <AppSection top>
      <AppContainer>
        <BlogBreadcrumbs :current="title" :category="post._embedded['wp:term'][0][0]" />
        <div class="flex justify-center">
          <BlogArticle :post />
        </div>
      </AppContainer>
    </AppSection>

    <RecentPosts v-if="recentPosts && recentPosts.length > 3" :posts="recentPosts" class="pt-0" />
  </div>
</template>

<script lang="ts" setup>
import { getFeaturedImage } from '~/helpers/blog';
import { stripHTML } from '~/helpers/format';

const { getPost, getPosts } = useWordpress();
const { slug } = useRoute().params;
const { data: posts } = await useAsyncData(`post_${slug}`, () => getPost(slug as string));
if (!posts.value || !posts.value.length) {
  throw createError({
    statusCode: 404,
    statusMessage: `No post found for slug "${slug}"`
  });
}
const post = posts.value[0]!;
const title = stripHTML(post.title.rendered);
useSchemaOrg('article', { post });
const image = getFeaturedImage(post, 'large');

usePageHead({
  title,
  description: stripHTML(post.excerpt.rendered),
  image: { ...image, alt: title },
  type: 'article'
});

const { data: recentPosts } = await useAsyncData(`posts_exc_${post.id}`, () => getPosts({ exclude: post.id }));

const { blogPost } = useStore();

blogPost.value = post;
onUnmounted(() => blogPost.value = null);
</script>